var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16 5.50003C16 8.53759 13.5376 11 10.5 11C10.1494 11 9.80656 10.9668 9.47416 10.9041L8.72378 11.7483C8.65342 11.8274 8.56708 11.8908 8.47046 11.9342C8.37385 11.9776 8.26913 12 8.16322 12H7V13.25C7 13.6642 6.66422 14 6.25 14H5V15.25C5 15.6642 4.66422 16 4.25 16H0.75C0.335781 16 0 15.6642 0 15.25V12.8107C0 12.6118 0.0790312 12.421 0.219656 12.2803L5.27597 7.224C5.09712 6.68169 5 6.10222 5 5.5C5 2.46244 7.46241 3.12503e-05 10.5 2.98518e-10C13.5465 -3.12497e-05 16 2.45347 16 5.50003ZM10.5 4C10.5 4.82844 11.1716 5.5 12 5.5C12.8284 5.5 13.5 4.82844 13.5 4C13.5 3.17156 12.8284 2.5 12 2.5C11.1716 2.5 10.5 3.17156 10.5 4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.1f6a16c4701c9adcd36cc48c412c18c9.svg";
export { ForwardRef as ReactComponent };